/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Clock_LabelInputs */



/**
* | output |
* | --- |
* | "Clock" |
*
* @param {Summary_Clock_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_clock_label = /** @type {((inputs?: Summary_Clock_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Clock_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Horloge")
	if (locale === "de") return /** @type {LocalizedString} */ ("Uhr")
	if (locale === "it") return /** @type {LocalizedString} */ ("Orologio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Часы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reloj")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("钟")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クロック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घड़ी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Relógio")
	return /** @type {LocalizedString} */ ("Clock")
});